/**
 * Construye data para graficos de torta usando una lista de filas.
 * @param {Array<Object>} rows - Filas con label y count.
 * @param {string} labelKey - Clave del label.
 * @param {string} valueKey - Clave del valor numerico.
 * @param {Array<string>} colors - Lista de colores para slices.
 * @returns {Array<Object>} Data lista para Recharts.
 */
export const buildPieData = (rows, labelKey, valueKey, colors) => {
  if (!Array.isArray(rows)) return [];

  return rows.map((row, index) => ({
    name: row?.[labelKey] ?? 'Sin dato',
    value: Number(row?.[valueKey] ?? 0),
    fill: colors[index % colors.length],
  }));
};

/**
 * Obtiene el total de una lista de filas por clave numerica.
 * @param {Array<Object>} rows - Filas con valores numericos.
 * @param {string} valueKey - Clave del valor numerico.
 * @returns {number} Total acumulado.
 */
export const getTotalFromRows = (rows, valueKey) => {
  if (!Array.isArray(rows)) return 0;
  return rows.reduce((acc, row) => acc + Number(row?.[valueKey] ?? 0), 0);
};
